<template>
  <div class="modifications-window-component">
    <h1 class="window-title font-weight-regular">
      Модификации:
    </h1>
    <div class="button-group-section d-flex justify-space-between">
      <v-row dense class="justify-space-between">
        <v-col sm="5">
          <v-btn
            @click="back"
            class="button button-back"
            width="100%"
            color="#F1F3F6"
          >
            <font-awesome-icon icon="chevron-left" />
            Вернуться назад
          </v-btn>
        </v-col>
        <v-col sm="5"></v-col>
      </v-row>
    </div>

    <div class="food-modifications-section">
      <food-card
        v-for="(item, i) in itemsWithModifications"
        :key="i"
        :item="item"
      />
    </div>

    <div v-if="!itemsWithModifications.length" class="d-flex justify-center">
      <span class="mt-10 display-3">Нет блюд с модификациями</span>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import FoodCard from './FoodCard'
  import OrderEdit from '@/mixins/order-edit'

  export default {
    name: 'ModificationsWindow',
    components: {
      FoodCard,
    },
    mixins: [
      OrderEdit,
    ],
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
      }),
      ...mapGetters({
        basketItems: 'baskets/getItems',
      }),
      itemsWithModifications () {
        if (!this.basketItems) {
          return []
        }
        return this.basketItems.filter(
          (item) => !!item.menuItem.modifications.length,
        )
      },
    },
    methods: {
      back () {
        this.$store.commit(this.orderEditPrefix + '/setCurrentOtherWindow', undefined)
      },
    },
  }
</script>

<style lang="less" scoped>
.modifications-window-component {
  .window-title {
    font-size: 34px;
    line-height: 21px;
    margin-bottom: 32px;
  }

  .label {
    display: block;
    margin-bottom: 16px;
    font-size: 20px;
    line-height: 21px;
  }

  .textarea {
    ::v-deep {
      &.v-input__slot {
        border-radius: 15px;
        background-color: @color-secondary;
      }
    }
  }

  .button {
    height: 80px;
    background-color: @color-secondary;
    font-size: 15px;
    box-shadow: 0 3px 6px #00000029 !important;
    border-radius: 10px !important;
    font-weight: 500;

    &.v-item--active {
      background-color: @color-primary !important;
      color: #ffffff;
    }

    &:before {
      display: none;
    }

    svg {
      margin-right: 8px;
    }

    &.button-back {
      svg {
        .fill-svg(#0033ff);
      }
    }
  }

  .button-group-section {
    margin-bottom: 24px;
  }

  .food-comment-section {
    .ps {
      margin-right: -12px;
    }
    .food-cards {
      padding-right: 24px;
      max-height: 408px;
    }
  }
}
</style>
